import { Language } from "../const";
import { CATEGORIES, type MEDIA_TYPE, type PublicationType } from "../../const";

export const newsletterListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/pub/newsletter-en.json",
  [Language.TC]: "/data/tc/pub/newsletter-tc.json",
  [Language.SC]: "/data/sc/pub/newsletter-sc.json",
};
export function getNewsletterData(news_letter_json: any[]): PublicationType[] {
  const newsLetter: PublicationType[] = news_letter_json?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    link: item?.url ?? "",
    mediaType: item?.type as MEDIA_TYPE, // PDF

    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
    yearRange: item?.yearRange ?? [0, 0],
  }));

  return newsLetter;
}
